module.exports = __webpack_public_path__ + "img/military.9c498734.png";